import * as React from 'react';

// Use an interval to repeatedly check up to X times if a main content container is available (to ensure we let CSR'd pages have time to load their content).
// This lets us know whether we should render a "skip to main content" button for screen reader users.
const useIsMainContentContainerAvailable = (intervalTimeout = 500, totalIntervalsUntilClear = 40) => {
  const [isMainContentContainerAvailable, setIsMainContentContainerAvailable] = React.useState(false);
  const intervalRef = React.useRef<number | undefined>();
  const intervalCountRef = React.useRef(0);

  const clearIntervalRef = () => {
    if (intervalRef?.current) {
      clearInterval(intervalRef.current);
    }
  };

  const checkMainContentContainer = () => {
    const isMainElementPresent = !!document.getElementById('main');

    intervalCountRef.current += 1;

    if (isMainElementPresent) {
      setIsMainContentContainerAvailable(true);
      clearIntervalRef();
    }

    if (intervalCountRef.current > totalIntervalsUntilClear) {
      clearIntervalRef();
    }
  };

  React.useEffect(() => {
    intervalRef.current = window.setInterval(checkMainContentContainer, intervalTimeout);

    return () => {
      if (intervalRef.current) {
        clearIntervalRef();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isMainContentContainerAvailable;
};

export default useIsMainContentContainerAvailable;
